export const LOADER_FORMAT_SET = 'LOADER_FORMAT_SET';

export const setLoaderFormat = format => ({
  type: LOADER_FORMAT_SET,
  format
});


// WEBPACK FOOTER //
// ./src/scenes/data-manager/loader/actions.js